import BTSelect from "react-select";
import { useTheme } from "styled-components";

import { SelectStyles } from "./Form.styles";

export const Select = (props) => {
  const theme = useTheme();
  return (
    <BTSelect
      styles={SelectStyles(theme)}
      components={{
        IndicatorSeparator: () => null,
      }}
      {...props}
    />
  );
};
